export const TOKENIZED_ACCOUNT_NUMBER_IDENTIFIER_TYPE = "tokenized_account_number";

export const TOKENIZED_ACCOUNT_NUMBER_STAFF_NOTICE =
  "The account number shown here is a secure number from the member's bank connection. It may not match the account number on the member's bank statements.";

export function isTokenizedAccountNumber(identifierType?: string | null): boolean {
  return identifierType === TOKENIZED_ACCOUNT_NUMBER_IDENTIFIER_TYPE;
}
